// Auditoria: quem fez o quê. Admin vê tudo; gestor de planta, o do próprio grupo.

import { useQuery } from "@tanstack/react-query";
import { EmptyState, PageHeader, Spinner, Table } from "../../components/ui";
import { api, type AuditEntry } from "../../lib/api";

const ACTION_LABEL: Record<string, string> = {
  login: "Entrou",
  logout: "Saiu",
  login_falhou: "Senha incorreta",
  login_recusado: "Login recusado",
  mfa_falhou: "Código 2FA incorreto",
  mfa_ativado: "Ativou o 2FA",
  mfa_desativado: "Desativou o 2FA",
  mfa_zerado: "Zerou o 2FA de um usuário",
  senha_trocada: "Trocou a senha",
  senha_definida: "Definiu a senha",
  senha_recuperacao_pedida: "Pediu recuperação de senha",
  convite_enviado: "Enviou convite",
  usuario_criado: "Criou usuário",
  usuario_alterado: "Alterou usuário",
  usuario_bloqueado: "Bloqueou usuário",
  vinculo_concedido: "Concedeu acesso",
  vinculo_removido: "Removeu acesso",
  grupo_criado: "Criou grupo",
  grupo_alterado: "Alterou grupo",
  grupo_removido: "Removeu grupo",
  usina_criada: "Criou usina",
  usina_alterada: "Alterou usina",
  usina_removida: "Removeu usina",
  ug_criada: "Criou UG",
  ug_alterada: "Alterou UG",
  ug_removida: "Removeu UG",
  regulador_criado: "Criou regulador",
  regulador_alterado: "Alterou regulador",
  regulador_removido: "Removeu regulador",
  fonte_vinculada: "Vinculou fonte",
  marca_alterada: "Alterou identidade visual",
  logo_alterado: "Alterou logo",
  cliente_configurado: "Configurou cliente",
};

export function AuditPage() {
  const { data, isLoading } = useQuery({ queryKey: ["audit"], queryFn: () => api.get<{ entries: AuditEntry[] }>("/api/admin/audit?limit=200") });
  const entries = data?.entries ?? [];
  return (
    <>
      <PageHeader title="Auditoria" description="Últimas 200 ações registradas." />
      {isLoading ? (
        <Spinner />
      ) : entries.length === 0 ? (
        <EmptyState title="Nada registrado" />
      ) : (
        <Table>
          <thead>
            <tr>
              <th>Quando</th>
              <th>Quem</th>
              <th>Ação</th>
              <th>Detalhe</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e, i) => (
              <tr key={i}>
                <td className="whitespace-nowrap text-xs text-muted">{new Date(e.ts).toLocaleString("pt-BR")}</td>
                <td className="text-xs">{e.email ?? "sistema"}</td>
                <td>{ACTION_LABEL[e.action] ?? e.action}</td>
                <td className="max-w-md truncate font-mono text-xs text-muted" title={detail(e)}>
                  {detail(e)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}

function detail(e: AuditEntry): string {
  const parts = [e.target, e.detail ? JSON.stringify(e.detail) : null, e.ip ? `ip ${e.ip}` : null];
  return parts.filter(Boolean).join(" · ");
}
